/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Titleposition2Inputs */

const en_formfields_titleposition2 = /** @type {(inputs: Formfields_Titleposition2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title / position`)
};

/**
* | output |
* | --- |
* | "Title / position" |
*
* @param {Formfields_Titleposition2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_titleposition2 = /** @type {((inputs?: Formfields_Titleposition2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Titleposition2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_titleposition2(inputs)
});
export { formfields_titleposition2 as "formFields_titlePosition" }